var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowEditAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E3FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.2536H12.275C12.3573 18.2541 12.4388 18.2383 12.5149 18.2072C12.5911 18.1761 12.6603 18.1303 12.7188 18.0724L17.0438 13.7411L18.8187 12.0036C18.8773 11.9455 18.9238 11.8764 18.9556 11.8002C18.9873 11.7241 19.0036 11.6424 19.0036 11.5599C19.0036 11.4774 18.9873 11.3957 18.9556 11.3195C18.9238 11.2434 18.8773 11.1742 18.8187 11.1161L16.1687 8.43487C16.1106 8.37629 16.0415 8.3298 15.9654 8.29807C15.8892 8.26634 15.8075 8.25 15.725 8.25C15.6425 8.25 15.5608 8.26634 15.4846 8.29807C15.4085 8.3298 15.3394 8.37629 15.2812 8.43487L13.5187 10.2036L9.18125 14.5349C9.12332 14.5933 9.0775 14.6625 9.04639 14.7387C9.01529 14.8148 8.99952 14.8964 9 14.9786V17.6286C9 17.7944 9.06585 17.9534 9.18306 18.0706C9.30027 18.1878 9.45924 18.2536 9.625 18.2536ZM15.725 9.75987L17.4937 11.5286L16.6062 12.4161L14.8375 10.6474L15.725 9.75987ZM10.25 15.2349L13.9563 11.5286L15.725 13.2974L12.0188 17.0036H10.25V15.2349ZM19.625 19.5036H8.375C8.20924 19.5036 8.05027 19.5695 7.93306 19.6867C7.81585 19.8039 7.75 19.9629 7.75 20.1286C7.75 20.2944 7.81585 20.4534 7.93306 20.5706C8.05027 20.6878 8.20924 20.7536 8.375 20.7536H19.625C19.7908 20.7536 19.9497 20.6878 20.0669 20.5706C20.1842 20.4534 20.25 20.2944 20.25 20.1286C20.25 19.9629 20.1842 19.8039 20.0669 19.6867C19.9497 19.5695 19.7908 19.5036 19.625 19.5036Z",
    fill: "#469369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowEditAction);
export default __webpack_public_path__ + "static/media/Row_Edit_Action.f176f62038acaf0e14850f79ca1353f2.svg";
export { ForwardRef as ReactComponent };